// extracted by mini-css-extract-plugin
export default {"main":"MainPage_main__23g5M","textInfo":"MainPage_textInfo__ulZUW"};